import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  InputAdornment,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { ApdexFormDispatchContext } from ".";
import { useTranslation } from 'react-i18next';

export function FormPaso({ paso, umbrales, changePasosEditable }) {
  const { t } = useTranslation();
  const [slaOkApdex, setSlaOkApdex] = useState(umbrales?.sla_ok_apdex ?? "0.0");
  const [slaOkTiempo, setSlaOkTiempo] = useState(
    umbrales?.sla_ok_tiempo ?? "0.0"
  );
  const [slaErrorApdex, setSlaErrorApdex] = useState(
    umbrales?.sla_error_apdex ?? "0.0"
  );
  const [slaErrorTiempo, setSlaErrorTiempo] = useState(
    umbrales?.sla_error_tiempo ?? "0.0"
  );
  const dispatch = useContext(ApdexFormDispatchContext);

  const slaOkApdexErrors = useMemo(() => {
    const errors = [];
    if (Number(slaOkApdex) < Number(slaErrorApdex)) {
      errors.push('apdex.errors.slaOkApdex.greaterThanFrustrado');
    }
    if (Number(slaOkApdex) > 1) {
      errors.push('apdex.errors.value.maxOne');
    }
    if (Number(slaOkApdex) <= 0) {
      errors.push('apdex.errors.value.greaterThanZero');
    }
    return errors;
  }, [slaOkApdex, slaErrorApdex]);

  const slaErrorApdexErrors = useMemo(() => {
    const errors = [];
    if (Number(slaErrorApdex) > Number(slaOkApdex)) {
      errors.push('apdex.errors.slaErrorApdex.lessThanOk');
    }
    if (Number(slaErrorApdex) > 1) {
      errors.push('apdex.errors.value.maxOne');
    }
    if (Number(slaErrorApdex) <= 0) {
      errors.push('apdex.errors.value.greaterThanZero');
    }
    return errors;
  }, [slaErrorApdex, slaOkApdex]);

  const slaOkTiempoErrors = useMemo(() => {
    const errors = [];
    if (Number(slaOkTiempo) > Number(slaErrorTiempo)) {
      errors.push('apdex.errors.slaOkTiempo.lessThanFrustradoTiempo');
    }
    if (Number(slaOkTiempo) > 59) {
      errors.push('apdex.errors.value.max59sec');
    }
    if (Number(slaOkTiempo) <= 0) {
      errors.push('apdex.errors.value.greaterThanZeroSec');
    }
    return errors;
  }, [slaErrorTiempo, slaOkTiempo]);

  const slaErrorTiempoErrors = useMemo(() => {
    const errors = [];
    if (Number(slaErrorTiempo) < Number(slaOkTiempo)) {
      errors.push('apdex.errors.slaErrorTiempo.greaterThanSatisfactorioTiempo');
    }
    if (Number(slaErrorTiempo) > 59) {
      errors.push('apdex.errors.value.max59sec');
    }
    if (Number(slaErrorTiempo) <= 0) {
      errors.push('apdex.errors.value.greaterThanZeroSec');
    }
    return errors;
  }, [slaErrorTiempo, slaOkTiempo]);

  useEffect(() => {
    const formStatus =
      slaOkApdexErrors.length === 0 &&
      slaErrorApdexErrors.length === 0 &&
      slaOkTiempoErrors.length === 0 &&
      slaErrorTiempoErrors.length === 0;
    dispatch({
      type: "SET_PASO_STATUS",
      paso,
      formStatus,
    });
  }, [
    slaOkApdexErrors,
    slaErrorApdexErrors,
    slaOkTiempoErrors,
    slaErrorTiempoErrors,
    dispatch,
    paso,
  ]);

  function editarUmbral({ key, value, groupKey, setFn }) {
    changePasosEditable({ key, value, groupKey });
    setFn(value);
  }

  function preventPaste(e) {
    e.preventDefault();
    return false;
}

  return (
    <Fragment>
      <TableRow>
        <TableCell width="200px">
          <Tooltip title={paso} placement="bottom">
            <Typography>{paso}</Typography>
          </Tooltip>
        </TableCell>
          <TableCell width="200px" style={{ paddingTop: 12, paddingBottom: 5 }}>
          <TextField
            defaultValue={slaOkTiempo}
            variant="outlined"
            size="small"
            label={t('apdex.labels.slaOkTiempo')}
            type="number"
            onChange={(event) => {
              editarUmbral({
                value: event.target.value,
                key: "sla_ok_tiempo",
                groupKey: "umbrales",
                setFn: setSlaOkTiempo,
              });
            }}
            onBlur={() => {}}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">{t('apdex.unit.sec')}</InputAdornment>
              ),
            }}
            error={slaOkTiempoErrors.length > 0}
            helperText={slaOkTiempoErrors.length ? t(slaOkTiempoErrors[0]) : ""}
            FormHelperTextProps={{
              style: {
                fontSize: "10px",
              },
            }}
            onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨", "`"].includes(e.key) && e.preventDefault()}
            onPaste={preventPaste}
          />
        </TableCell>
          <TableCell width="200px" style={{ paddingTop: 12, paddingBottom: 5 }}>
          <TextField
            defaultValue={slaErrorTiempo}
            variant="outlined"
            size="small"
            label={t('apdex.labels.slaErrorTiempo')}
            type="number"
            onChange={(event) => {
              editarUmbral({
                value: event.target.value,
                key: "sla_error_tiempo",
                groupKey: "umbrales",
                setFn: setSlaErrorTiempo,
              });
            }}
            onBlur={() => {}}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">{t('apdex.unit.sec')}</InputAdornment>
              ),
            }}
            error={slaErrorTiempoErrors.length > 0}
            helperText={slaErrorTiempoErrors.length ? t(slaErrorTiempoErrors[0]) : ""}
            FormHelperTextProps={{
              style: {
                fontSize: "10px",
              },
            }}
            onKeyDown={(e) =>["e", "E", "+", "-", ".", "´", "¨", "`"].includes(e.key) && e.preventDefault()}
            onPaste={preventPaste}
          />
        </TableCell>
          <TableCell width="200px" style={{ paddingTop: 12, paddingBottom: 5 }}>
          <TextField
            defaultValue={slaOkApdex}
            variant="outlined"
            size="small"
            label={t('apdex.labels.slaOkApdex')}
            type="number"
            onChange={(event) => {
              editarUmbral({
                value: event.target.value,
                key: "sla_ok_apdex",
                groupKey: "umbrales",
                setFn: setSlaOkApdex,
              });
            }}
            onBlur={() => {}}
            fullWidth
            error={slaOkApdexErrors.length > 0}
            helperText={slaOkApdexErrors.length ? t(slaOkApdexErrors[0]) : ""}
            FormHelperTextProps={{
              style: {
                fontSize: "10px",
              },
            }}
            onKeyDown={(e) =>["e", "E", "+", "-", "´", "¨", "`"].includes(e.key) && e.preventDefault()}
            onPaste={preventPaste}
          />
        </TableCell>
          <TableCell width="200px" style={{ paddingTop: 12, paddingBottom: 5 }}>
          <TextField
            defaultValue={slaErrorApdex}
            variant="outlined"
            size="small"
            label={t('apdex.labels.slaErrorApdex')}
            type="number"
            onChange={(event) => {
              editarUmbral({
                value: event.target.value,
                key: "sla_error_apdex",
                groupKey: "umbrales",
                setFn: setSlaErrorApdex,
              });
            }}
            onBlur={() => {}}
            fullWidth
            error={slaErrorApdexErrors.length > 0}
            helperText={slaErrorApdexErrors.length ? t(slaErrorApdexErrors[0]) : ""}
            FormHelperTextProps={{
              style: {
                fontSize: "10px",
              },
            }}
            onKeyDown={(e) =>["e", "E", "+", "-", "´", "¨", "`"].includes(e.key) && e.preventDefault()}
            onPaste={preventPaste}
          />
        </TableCell>
      </TableRow>
    </Fragment>
  );
}
